import {
  FONT_COLOR,
  FONT_SIZE,
  inlineStyle,
} from "../../../../../style/const/chat/inline_style"
import { HEADLINE_BORDER_COLOR_STYLES } from "../../../../../style/const/chat/block_style"
import { IStyle } from "../../../../../style/const/chat/interface"
import Color from "../../../../../style/enum/color"

const getColorCode = (fontColorName: FONT_COLOR) => {
  const selectedFontColor: IStyle = inlineStyle.find(
    style => style.name === fontColorName,
  ) as IStyle
  return selectedFontColor.css.color
}

// inline style

// FONT-COLOR
export const FONT_COLOR_STYLE_MAP_WITH_BUTTON_TITLE = [
  { label: FONT_COLOR.BLUE, colorCode: getColorCode(FONT_COLOR.BLUE) },
  { label: FONT_COLOR.GREEN, colorCode: getColorCode(FONT_COLOR.GREEN) },
  { label: FONT_COLOR.ORANGE, colorCode: getColorCode(FONT_COLOR.ORANGE) },
  { label: FONT_COLOR.RED, colorCode: getColorCode(FONT_COLOR.RED) },
  { label: null, colorCode: Color.BLACK }, // 色リセット
]

// FONT-SIZE
export const FONT_SIZE_STYLE_MAP_WITH_BUTTON_TITLE = [
  { name: "文字の大きさ", key: "", value: "" },
  { name: "小", key: FONT_SIZE.SMALL, value: FONT_SIZE.SMALL },
  { name: "中", key: FONT_SIZE.MEDIUM, value: FONT_SIZE.MEDIUM },
  { name: "大", key: FONT_SIZE.LARGE, value: FONT_SIZE.LARGE },
]

// block style

// HEADLINE-BORDER-COLOR
export const HEADLINE_BORDER_COLOR: Array<{
  name: string
  id: number
  className: string
}> = [
  {
    name: "青",
    id: HEADLINE_BORDER_COLOR_STYLES[0].id,
    className: HEADLINE_BORDER_COLOR_STYLES[0].name,
  },
  {
    name: "黒",
    id: HEADLINE_BORDER_COLOR_STYLES[1].id,
    className: HEADLINE_BORDER_COLOR_STYLES[1].name,
  },
  {
    name: "無し",
    id: HEADLINE_BORDER_COLOR_STYLES[2].id,
    className: HEADLINE_BORDER_COLOR_STYLES[2].name,
  },
]

export const HEADLINE_BORDER_COLOR_DEFAULT_ID = HEADLINE_BORDER_COLOR[0].id
